import {
  ByDateCard,
  ByDateCardVariantEnum,
} from '@app/feature/statistics/components/by-date-card/by-date.card';
import { useCpmsBoGetEnergyDeliveredByMonthQuery } from '@service/cpms-bo-transaction-reports-energy-statistics.service';

import { useFilters } from '../../context/filters.context';

export const EnergyByMonthCard = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();
  const { data } = useCpmsBoGetEnergyDeliveredByMonthQuery({
    ...transformedFilters,
  });

  return <ByDateCard data={data} variant={ByDateCardVariantEnum.Energy} />;
};
